<template>
  <div class="exercise-guide">
    <div
      class="
        exercise-detail__feedback
        exercise-guide__feedback
        display-flex-center
      "
      :class="isMobile ? 'justify-content-center' : 'justify-content-between'"
    >
      <a
        href="javascript:;"
        v-if="!showGuideContent"
        class="secondary-color-txt"
        @click="toggleGuideContent"
        >Xem hướng dẫn</a
      >
      <a
        href="javascript:;"
        v-else
        class="primary-color"
        @click="toggleGuideContent"
        >Ẩn hướng dẫn</a
      >
      <a
        v-if="!isMobile"
        href="javascript:;"
        class="secondary-color-txt"
        @click="openModalNotiErrorQuestion"
        >Gửi yêu cầu!</a
      >
    </div>
    <transition name="fade" v-if="showGuideContent">
      <div class="exercise-detail__guide">
        <b-tabs content-class="mt-3">
          <b-tab title="Hướng dẫn" @click="onClickTab">
            <div
              class="
                exercise-detail__guide__content
                font-size-16
                primary-color-txt
              "
            >
              <span
                class="
                  display-block
                  font-size-16
                  secondary-color-txt
                  font-sanpro
                "
                >{{ versionApp }}</span
              >
              <!-- <template v-if="question && question.type && question.type === typeGroup">
                  <div class="child-item" v-for="(guide, index) of question.listQuestionChild" :key="`guide_${index}`">
                    <b v-if="authInfo.email != emailPublic && (isShowGuideForce || (isShowGuide && guide && guide.title))">{{ guide.title }}</b>
                    <div v-if="authInfo.email != emailPublic && (isShowGuideForce || (isShowGuide && guide && guide.guideContent))" class="guide__content" v-html="replaceLinkImg(guide.guideContent)"></div>
                  </div>
                </template>
                <div v-else class="guide__content" v-html="authInfo.email != emailPublic && (isShowGuideForce || (isShowGuide && question && question.guideContent)) ? replaceLinkImg(question.guideContent) : txtNotContent"></div> -->
              <div
                class="guide__content"
                v-html="
                  authInfo.email != emailPublic
                    ? replaceLinkImg(question.guideContent)
                    : txtNotContent
                "
              ></div>
            </div>
          </b-tab>
          <b-tab
            title="Lời giải chi tiết"
            :active="question && !question.guideContent"
            @click="onClickTab"
          >
            <span
              class="display-block font-size-16 secondary-color-txt font-sanpro"
              >{{ versionApp }}</span
            >
            <div
              class="
                exercise-detail__guide__content
                font-size-16
                primary-color-txt
              "
            >
              <!-- <template
                v-if="question && question.type && question.type === typeGroup"
              >
                <div
                  class="child-item"
                  v-for="(and, index) of question.listQuestionChild"
                  :key="`and_${index}`"
                >
                  <b
                    v-if="
                      authInfo.email != emailPublic &&
                      (isShowGuideForce || (isShowGuide && and && and.title))
                    "
                    >{{ and.title }}</b
                  >
                  <div
                    v-if="
                      authInfo.email != emailPublic &&
                      (isShowGuideForce ||
                        (isShowGuide && and && and.answerDetail))
                    "
                    class="answer__detail__content"
                    v-html="replaceLinkImg(and.answerDetail)"
                  ></div>
                </div>
              </template>
              <div
                v-else
                class="answer__detail__content"
                v-html="
                  authInfo.email != emailPublic &&
                  (isShowGuideForce ||
                    (isShowGuide && question && question.answerDetail))
                    ? replaceLinkImg(question.answerDetail)
                    : txtNotContent
                "
              ></div> -->
              <div
                class="answer__detail__content"
                v-html="
                  authInfo.email != emailPublic
                    ? replaceLinkImg(question.answerDetail)
                    : txtNotContent
                "
              ></div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </transition>
    <div
      class="overlay-question"
      v-if="valVituralKeyboard.location > -1 && screenWidth > 991"
      @click="resetValKeyboard"
    ></div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  STORE_KEY as STORE_KEY_QUESTION,
  TYPE_GROUP,
} from "@/modules/question/preview-question/_store/constants";
import { APP_CONFIG } from "@/utils/constants";
import JWT from "@/utils/jwt";
import { EMAIL_PUBLIC } from "@/store/auth/constants";
export default {
  name: "ExerciseGuide",
  props: {
    question: Object,
    handleShowGuide: Boolean,
    isMobile: Boolean,
    isShowGuide: Boolean,
  },
  data() {
    return {
      isAuthorize: JWT.getAccessToken(),
      authInfo: JWT.getAuth(),
      showGuideContent: false,
      typeGroup: TYPE_GROUP,
      emailPublic: EMAIL_PUBLIC,
      errorTypeId: 2,
      txtNotContent:
        '<p class="text-center secondary-color-txt font-size-18">Nội dung đang được cập nhật!</p>',
      isShowGuideForce: false,
      configKeyclock: {},
    };
  },
  computed: {
    ...mapState("common", ["versionApp"]),
    ...mapState(STORE_KEY_QUESTION, ["valVituralKeyboard"]),
    screenWidth() {
      return window.innerWidth;
    },
  },
  watch: {
    handleShowGuide(newVal) {
      this.showGuideContent = newVal;
      if (this.showGuideContent) {
        this.checkShowGuideForce();
      }
    },
  },
  methods: {
    ...mapActions("auth", ["setToggleLoginForm", "setToggleLoginSSOForm"]),
    ...mapActions("common", ["acToggleModaShowError"]),
    ...mapActions(STORE_KEY_QUESTION, ["setVituralKeyVal"]),
    async onCheckLogin() {
      if (this.authInfo.email != this.emailPublic) {
        return;
      }
      const request = await fetch(APP_CONFIG.dataUrl + "IsLoginkeyCloak");
      const response = await request.json();
      this.configKeyclock = response;
      if (this.configKeyclock.isLoginKeyClock == 0) {
        this.setToggleLoginForm(true);
      } else {
        this.setToggleLoginSSOForm(true);
      }
    },
    resetValKeyboard() {
      this.valVituralKeyboard && this.setVituralKeyVal({});
    },
    onClickTab() {
      this.onCheckLogin();
    },
    toggleGuideContent() {
      this.showGuideContent = !this.showGuideContent;
      if (this.showGuideContent) {
        this.onCheckLogin();
        this.checkShowGuideForce();
      }
    },
    checkShowGuideForce() {
      for (let i = 0; i < this.question.answers.length; i++) {
        if (this.question.answers[i].answerContent) {
          this.isShowGuideForce = true;
        } else {
          this.isShowGuideForce = false;
          break;
        }
      }
    },
    openModalNotiErrorQuestion() {
      this.acToggleModaShowError({
        isShow: true,
        errorTypeId: this.errorTypeId,
      });
    },

    replaceLinkImg(content) {
      if (!content) {
        return;
      }
      const linkImg = new RegExp(APP_CONFIG.cmsLinkImg, "g");
      return content.replace(linkImg, APP_CONFIG.cdnLive);
    },
  },
};
</script>

<style lang="scss" scoped>
.exercise-guide {
  margin-top: 20px;

  &__feedback {
    margin-bottom: 25px;
  }
}
</style>